// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Montserrat */
const MS = /^(?:664(?:3(?:49|9[1-6])|49[2-6])\d{4})$/;

export default MS;
